<script lang="ts">
  import { Accordion, AccordionItem, CardBody, Col, Image } from "sveltestrap";
  import data from "../../../../Data/Users/Users.json"
  let imgPath:string = "/assets/images/user"

</script>
<Col xl="12" lg="6" md="12" sm="6" >
    <Accordion>
        <AccordionItem active header="Latest Photos">
            <CardBody class="avatar-showcase filter-cards-view">
                {#each data.userfrindsdata as photoItem}
                    <div class="d-inline-block friend-pic">
                        <Image class="img-50 rounded-circle" alt="#" src="{imgPath}/{photoItem}" />
                    </div>
                {/each}
            </CardBody>    
        </AccordionItem>
    </Accordion>
</Col>
